import { AdminPageLayout } from "@/features/admin/components/AdminPageLayout";
import { OrganisationNavTabs } from "@/features/admin/components/OrganisationNavTabs";
import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/admin/organisation")({
    component: OrganisationLayout,
});

function OrganisationLayout() {
    return (
        <AdminPageLayout
            title="Organisations"
            description="Add organisations, manage logos, and review usage statistics."
        >
            <div className="space-y-6">
                <OrganisationNavTabs />
                <Outlet />
            </div>
        </AdminPageLayout>
    );
}
